var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    stroke: "#ECEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12722 11.334L3.88574 20.9963H8.96339L9.59287 19.4557H11.0317L11.6612 20.9963H17.2503V19.8205L17.7483 20.9963H20.6394L21.1374 19.7956V20.9963H32.7611L34.1745 19.4957L35.498 20.9963L41.4682 21.0087L37.2133 16.1921L41.4682 11.334H35.5906L34.2147 12.8068L32.9329 11.334H20.2878L19.202 13.8279L18.0907 11.334H13.0237V12.4698L12.46 11.334H8.12722ZM9.11017 12.7061H11.5852L14.3986 19.2581V12.7061H17.11L19.283 17.4039L21.2857 12.7061H23.9835V19.6394H22.3419L22.3285 14.2065L19.9353 19.6394H18.4668L16.0602 14.2065V19.6394H12.6832L12.0429 18.085H8.58403L7.94513 19.638H6.13574L9.11017 12.7061ZM32.1603 12.7061H25.4854V19.6353H32.0569L34.175 17.3388L36.2165 19.6353H38.3507L35.2488 16.1908L38.3507 12.7061H36.3091L34.2018 14.9762L32.1603 12.7061ZM10.3134 13.8792L9.17383 16.6481H11.4516L10.3134 13.8792ZM27.1328 15.4073V14.1416V14.1404H31.2977L33.1151 16.1645L31.2172 18.1997H27.1328V16.818H30.7743V15.4073H27.1328Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american_express.0343751c55370f1a85cba19c1e307113.svg";
export { ForwardRef as ReactComponent };